import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Modal from './ModalV2'; //ModelV1

// Entrypoint for all modals
function ConnectedModalWrapper({ height, modal }) {
  return (
    <Modal height={height} title={modal.title} description={modal.description} active={modal.active}
      content={modal.content} enableHeader={modal.enableHeader} style={modal.style}
      underlayClickExits={modal.underlayClickExits} underlayBackground={modal.underlayBackground}
    />
  )
}

ConnectedModalWrapper.propTypes = {
  height: PropTypes.number.isRequired,
  modal: PropTypes.object.isRequired
}

const ModalWrapper = connect(
  state => ({ modal: state.modal })
)(ConnectedModalWrapper);

export default ModalWrapper;
